import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

interface FeaturedComicsProps {
  comicIds: string[];
  title: string;
  subtitle?: string;
}

export default function FeaturedComics({ comicIds, title, subtitle }: FeaturedComicsProps) {
  const featuredComics = comicIds.map((id) => comics.find((c) => c.id === id)).filter(Boolean);

  return (
    <section className="py-10 md:py-14">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">{title}</h2>
          {subtitle && <p className="text-sm text-foreground-600">{subtitle}</p>}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {featuredComics.map((comic) => (
            comic && (
              <Link
                key={comic.id}
                to={`/comic/${comic.id}`}
                className="group cursor-pointer"
              >
                <div className="relative overflow-hidden rounded-lg mb-3 aspect-[5/7]">
                  <img
                    src={comic.coverImage}
                    alt={comic.title}
                    title={`${comic.title} - ${comic.author}`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute top-2 right-2 px-2 py-0.5 rounded-full text-xs font-label bg-accent-500 text-background-50 whitespace-nowrap">
                    {comic.rating}
                  </div>
                  {comic.status === '已完结' && (
                    <div className="absolute top-2 left-2 px-2 py-0.5 rounded-full text-xs font-label bg-foreground-800/70 text-background-50 whitespace-nowrap">
                      已完结
                    </div>
                  )}
                </div>
                <h3 className="text-sm md:text-base font-heading text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1 line-clamp-2">{comic.description}</p>
              </Link>
            )
          ))}
        </div>
      </div>
    </section>
  );
}